// 获取 type 参数
export const getParams = (paramStr) => {
  // 对于 Hash 路由：http://localhost:3000/#/quickTask?type=top
  const hash = window.location.hash; // 得到 "#/quickTask?type=top"
  const queryString = hash.split('?')[1]; // 得到 "type=top"
  
  if (queryString) {
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(paramStr); // 返回 "top"
  }
  return null;
};